var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCustomerServiceLine = function SvgCustomerServiceLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 16.502a5.4 5.4 0 0 1-4.242 5.274l-.574-1.723a3.6 3.6 0 0 0 2.534-1.753H16.5a1.8 1.8 0 0 1-1.8-1.8v-3.6a1.8 1.8 0 0 1 1.8-1.8h2.644a7.201 7.201 0 0 0-14.288 0H7.5a1.8 1.8 0 0 1 1.8 1.8v3.6a1.8 1.8 0 0 1-1.8 1.8H4.8A1.8 1.8 0 0 1 3 16.5V12a9 9 0 0 1 9-9 9 9 0 0 1 9 9zm-1.8-.002v-3.6h-2.7v3.6zM4.8 12.9v3.6h2.7v-3.6z"
  })));
};
export default SvgCustomerServiceLine;